import { useState } from "react";
import { addBanner, updateBanner } from "../../../firebase/services";
import { B, fonts, Input, Btn, ImageUpload } from "../../../components/UI";

// Banner create/edit form extracted from Dashboard.
export default function BannerForm({ initial, nextOrder, onDone, showToast, onSavingChange }) {
  const blank = { title: "", subtitle: "", badge: "", price: "", videoUrl: "", order: nextOrder };
  const [form, setForm] = useState(initial || blank);
  const [imgFile, setImgFile] = useState(null);
  const [preview, setPreview] = useState(initial?.imageUrl || null);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    const payload = { ...form, videoUrl: (form.videoUrl || "").trim() };
    setSaving(true);
    onSavingChange?.(true);
    try {
      if (initial) await updateBanner(initial.id, payload, imgFile);
      else await addBanner(payload, imgFile);
      showToast("Banner saved");
      onDone();
    } catch (e) {
      showToast(e.message, B.red);
    } finally {
      setSaving(false);
      onSavingChange?.(false);
    }
  };

  return (
    <div style={{ background: B.orangeFaint, border: `1.5px solid ${B.orangeMid}`, borderRadius: 14, padding: 24, marginBottom: 24 }}>
      <div style={{ fontWeight: 800, fontSize: 16, color: B.text, marginBottom: 20, fontFamily: fonts.adminDisplay }}>
        {initial ? "✏️ Edit Banner" : "🖼️ Add Banner"}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 18px" }}>
        <Input label="Heading" value={form.title} onChange={e => set("title", e.target.value)} placeholder="e.g. Summer Collection" />
        <Input label="Badge / Label" value={form.badge} onChange={e => set("badge", e.target.value)} placeholder="e.g. New Arrival" />
        <Input label="Sub-text" value={form.subtitle} onChange={e => set("subtitle", e.target.value)} placeholder="e.g. Fresh designs just landed" />
        <Input label="Price Text" value={form.price} onChange={e => set("price", e.target.value)} placeholder="e.g. Starting ₹599" />
        <Input label="Video URL (optional)" value={form.videoUrl || ""} onChange={e => set("videoUrl", e.target.value)} placeholder="e.g. https://youtu.be/VIDEO_ID or https://cdn.example.com/banner.mp4" />
        <Input label="Display Order" value={form.order} onChange={e => set("order", parseInt(e.target.value, 10) || 0)} type="number" />
      </div>
      <ImageUpload preview={preview} onFile={f => { setImgFile(f); setPreview(URL.createObjectURL(f)); }} label="Banner Image" hint="Wide landscape image (1400×500px ideal)" width={180} height={80} />
      <div style={{ fontSize: 11, color: B.textLight, marginTop: 8, marginBottom: 4, fontFamily: fonts.body }}>
        Add a direct video file URL or YouTube link to play video in the website banner. If both are provided, video will be shown first.
      </div>
      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <Btn onClick={onDone} variant="ghost">Cancel</Btn>
        <Btn onClick={handleSave} disabled={saving} variant="primary">{saving ? "Saving..." : "Save Banner"}</Btn>
      </div>
    </div>
  );
}
